<template>
    <div>
        <v-img :height="25" src="/img/logo.svg"></v-img>
        <div :class="$vuetify.display.smAndDown?'f-s-22':'f-s-32'" class="text-h4 font-weight-bold text-black pt-4 pb-1">{{ $t('campaign_version_three.header_main') }}</div>
        <v-list lines="two" bg-color="transparent" density="compact">
            <v-list-item class="px-0 custom-list-item">
                <template v-slot:prepend>
                    <v-icon color="info" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>
                </template>
                <v-list-item-subtitle :class="$vuetify.display.smAndDown?'text-body-2':'text-body-1'" class="opacity-1 text-black">{{ $t('campaign_version_three.header_list_item_1') }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0 custom-list-item">
                <template v-slot:prepend>
                    <v-icon color="info" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>
                </template>
                <v-list-item-subtitle :class="$vuetify.display.smAndDown?'text-body-2':'text-body-1'" class="opacity-1 text-black">{{ $t('campaign_version_three.header_list_item_2') }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0 custom-list-item">
                <template v-slot:prepend>
                    <v-icon color="info" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>
                </template>
                <v-list-item-subtitle :class="$vuetify.display.smAndDown?'text-body-2':'text-body-1'" class="opacity-1 text-black">{{ $t('campaign_version_three.header_list_item_3') }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0 custom-list-item">
                <template v-slot:prepend>
                    <v-icon color="info" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>
                </template>
                <v-list-item-subtitle :class="$vuetify.display.smAndDown?'text-body-2':'text-body-1'" class="opacity-1 text-black">
                    <span>{{ $t('campaign_version_three.header_list_item_4') }}</span>
                </v-list-item-subtitle>
            </v-list-item>
        </v-list>
        <v-img src="/images/campaigns/version-three/list-image-widget-photo.png" class="custom-negative"/>
    </div>
</template>

<script>
export default {
    name: "ListImageWidget"
}
</script>

<style lang="scss">
.f-s-32 {
    font-size: 2rem!important;
    letter-spacing: 0!important;
}
.f-s-22 {
    font-size: 22px!important;
    letter-spacing: 0!important;
    line-height: 24px;
}
.opacity-1 {
    opacity: 1;
}
.custom-list-item {
    min-height: auto!important;
}
.custom-negative {
    margin-bottom: -105px;
    @media (max-width: 500px) {
        margin-bottom: -105px;
    }
    @media (max-width: 450px) {
        margin-bottom: -95px;
    }
    @media (max-width: 400px) {
        margin-bottom: -90px;
    }
}
</style>
